import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotAsyncChat" */ './lazyIndex'),
    { name: 'CopilotAsyncChat' }
);

export const lazyStartAsyncChat: LazyAction<typeof lazyIndex.startAsyncChat, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.startAsyncChat);
export const lazyMarkAsyncItemRead: LazyAction<
    typeof lazyIndex.markAsyncItemRead,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.markAsyncItemRead);
export const lazySeedAsyncItemRegistry: LazyAction<
    typeof lazyIndex.seedAsyncItemRegistryFromGetChats,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.seedAsyncItemRegistryFromGetChats);

// Payload types
export type { StartAsyncChatParams } from './commands/startAsyncChat';
export type { MarkAsyncItemReadPayload } from './commands/markAsyncItemRead';
export type { SeedAsyncItemRegistryFromGetChatsPayload } from './commands/seedAsyncItemRegistryFromGetChats';
